import { combineReducers } from 'redux';
import reducerTest from '../reducers/reducerTest'
import authReducer from '../reducers/authReducer'
import orderHistoryReducer from '../reducers/orderHistoryReducer';
import processOrderReducer from '../reducers/processOrderReducer';
import adminReducer from '../reducers/reducerAdmin'

export default combineReducers({
    userDetailsTest: reducerTest,
    userReducer: authReducer,
    orderHistory: orderHistoryReducer,
    orderReducer: processOrderReducer,
    adminData: adminReducer
});